module.exports = __webpack_public_path__ + "img/step-2.b8517c35.png";